import constants from "constants";
import {
  CLEAR_STUDY_GROUPS,
  SAVE_STUDYGROUPS_INFINITE,
} from "../constants/actions";

const {
  GET_STUDYGROUP,
  GET_STUDYGROUPS,
  GET_STUDYGROUPS_ADMIN,
  SAVE_STUDYGROUPS,
  CREATE_STUDYGROUP,
  UPDATE_STUDYGROUP,
  DELETE_STUDYGROUPS,
  SET_STUDYGROUP,
  CLEAN_STUDYGROUP,
  GET_GROUP_MEMBERS,
  SET_GROUP_MEMBERS,
  LOAD_GROUP_MATERIAL,
  SET_GROUP_MATERIAL_INFINITY,
  CREATE_STUDY_GROUP_MATERIALS,
  CLEAR_STUDY_GROUP_MATERIALS,
  SET_GROUP_MATERIAL,
  GET_GROUP_MATERIAL,
  DELETE_STUDY_GROUP_MATERIAL,
  UPDATE_GROUP_MATERIALS_AFTER_DELETE,
  GET_STUDY_GROUP_INVITES,
  SET_STUDY_GROUP_INVITES,
  GET_STUDY_GROUP_STATISTIC,
  SET_STUDY_GROUP_STATISTIC,
  GET_STUDY_GROUP_WEBINARS,
  SET_STUDY_GROUP_WEBINARS,
  DELETE_STUDY_GROUP_WEBINARS,
  GET_ADMIN_GROUP_MEMBERS,
  SET_ADMIN_GROUP_MEMBERS,
  SEND_GROUP_INVITES,
  GET_GROUP_INVITES,
  SET_GROUP_INVITES,
  DELETE_INVITE,
  DELETE_INVITE_SUCCESS,
  GET_COURSE_MATERIALS,
  SET_COURSE_MATERIALS,
  CREATE_COURSE_MATERIAL,
  UPDATE_COURSE_MATERIAL,
  SET_COURSE_MATERIAL,
  DELETE_COURSE_MATERIALS,
  JOIN_GROUP_FROM_LINK,
  CLEAR_COURSE_MATERIALS,
  DELETE_GROUP_MEMBER,
  DELETE_GROUP_INVITE,
  GET_STUDYGROUPS_INFINITE,
  USER_LEAVE_GROUP,
  GET_ADMIN_STUDYGROUP,
  UPDATE_STUDYGROUP_SUPERHOST,
  USER_REQUEST_TO_JOIN_GROUP,
  UPDATE_STUDY_GROUP_REQUEST,
  USER_CANCEL_REQUEST_STUDY_GROUP,
} = constants;

export const cleanStudyGroup = () => ({
  type: CLEAN_STUDYGROUP,
});

export const getStudygroups = (query, page = 1) => ({
  type: GET_STUDYGROUPS,
  query,
  page,
});

export const getStudygroupsInfinite = (query, page = 1) => ({
  type: GET_STUDYGROUPS_INFINITE,
  query,
  page,
});

export const getStudygroupsAdmin = (query, page = 1) => ({
  type: GET_STUDYGROUPS_ADMIN,
  query,
  page,
});

export const getStudygroup = (id) => ({
  type: GET_STUDYGROUP,
  id,
});

export const getAdminStudygroup = (id) => ({
  type: GET_ADMIN_STUDYGROUP,
  id,
});

export const setStudygroup = (studygroup) => ({
  type: SET_STUDYGROUP,
  studygroup,
});

export const saveStudygroups = (payload) => ({
  type: SAVE_STUDYGROUPS,
  payload,
});

export const saveStudygroupsInfinite = (payload) => ({
  type: SAVE_STUDYGROUPS_INFINITE,
  payload,
});

export const createStudygroup = (studygroup) => ({
  type: CREATE_STUDYGROUP,
  studygroup,
});

export const updateStudygroup = (studygroup) => ({
  type: UPDATE_STUDYGROUP,
  studygroup,
});

export const updateStudygroupSuperhost = (studygroup) => ({
  type: UPDATE_STUDYGROUP_SUPERHOST,
  studygroup,
});

export const deleteStudygroups = (studygroup_ids) => ({
  type: DELETE_STUDYGROUPS,
  studygroup_ids,
});

export const getGroupMembers = (payload) => ({
  type: GET_GROUP_MEMBERS,
  payload,
});

export const setGroupMembers = (payload) => ({
  type: SET_GROUP_MEMBERS,
  payload,
});

export const loadGroupMaterial = (payload) => ({
  type: LOAD_GROUP_MATERIAL,
  payload,
});

export const getGroupMaterials = (payload) => ({
  type: GET_GROUP_MATERIAL,
  payload,
});

export const setGroupMaterialInfinity = (payload) => ({
  type: SET_GROUP_MATERIAL_INFINITY,
  payload,
});

export const updateGroupMaterialsAfterDelete = (payload) => ({
  type: UPDATE_GROUP_MATERIALS_AFTER_DELETE,
  payload,
});

export const setGroupMaterials = (payload) => ({
  type: SET_GROUP_MATERIAL,
  payload,
});

export const createStudyGroupMaterial = (payload) => ({
  type: CREATE_STUDY_GROUP_MATERIALS,
  payload,
});

export const clearStudyGroupMaterial = () => ({
  type: CLEAR_STUDY_GROUP_MATERIALS,
});

export const deleteStudyGroupMaterial = (payload) => ({
  type: DELETE_STUDY_GROUP_MATERIAL,
  payload,
});

export const getStudyGroupInvites = (payload) => ({
  type: GET_STUDY_GROUP_INVITES,
  payload,
});

export const setStudyGroupInvites = (payload) => ({
  type: SET_STUDY_GROUP_INVITES,
  payload,
});

export const getStudyGroupStatistic = (payload) => ({
  type: GET_STUDY_GROUP_STATISTIC,
  payload,
});

export const setStudyGroupStatistic = (payload) => ({
  type: SET_STUDY_GROUP_STATISTIC,
  payload,
});

export const getStudyGroupWebinars = (payload) => ({
  type: GET_STUDY_GROUP_WEBINARS,
  payload,
});

export const setStudyGroupWebinars = (payload) => ({
  type: SET_STUDY_GROUP_WEBINARS,
  payload,
});

export const deleteStudyGroupWebinars = ({ ids, query }) => ({
  type: DELETE_STUDY_GROUP_WEBINARS,
  ids,
  query,
});

export const getAdminGroupMembers = (groupId, params) => ({
  type: GET_ADMIN_GROUP_MEMBERS,
  groupId,
  params,
});

export const setAdminGroupMembers = (payload) => ({
  type: SET_ADMIN_GROUP_MEMBERS,
  payload,
});

export const sendGroupInvites = (groupId, emails) => ({
  type: SEND_GROUP_INVITES,
  groupId,
  emails,
});

export const getGroupInvites = (groupId, params) => ({
  type: GET_GROUP_INVITES,
  groupId,
  params,
});

export const setGroupInvites = (payload) => ({
  type: SET_GROUP_INVITES,
  payload,
});

export const deleteInvite = (inviteId) => ({
  type: DELETE_INVITE,
  inviteId,
});

export const deleteInviteSuccess = (inviteId) => ({
  type: DELETE_INVITE_SUCCESS,
  inviteId,
});

export const getCourseMaterials = (groupId, params) => ({
  type: GET_COURSE_MATERIALS,
  groupId,
  params,
});

export const setCourseMaterials = (payload) => ({
  type: SET_COURSE_MATERIALS,
  payload,
});

export const clearCourseMaterials = () => ({
  type: CLEAR_COURSE_MATERIALS,
});

export const createCourseMaterial = (courseMaterial) => ({
  type: CREATE_COURSE_MATERIAL,
  courseMaterial,
});

export const setCourseMaterial = (courseMaterial) => ({
  type: SET_COURSE_MATERIAL,
  courseMaterial,
});

export const updateCourseMaterial = (courseMaterial) => ({
  type: UPDATE_COURSE_MATERIAL,
  courseMaterial,
});

export const deleteCourseMaterials = (materialsIds) => ({
  type: DELETE_COURSE_MATERIALS,
  materialsIds,
});

export const joinGroupFromLink = (payload) => ({
  type: JOIN_GROUP_FROM_LINK,
  payload,
});

export const deleteGroupMember = (payload) => ({
  type: DELETE_GROUP_MEMBER,
  payload,
});

export const deleteGroupInvite = (payload) => ({
  type: DELETE_GROUP_INVITE,
  payload,
});

export const clearStudyGroups = () => ({
  type: CLEAR_STUDY_GROUPS,
});

export const userLeaveGroup = () => ({
  type: USER_LEAVE_GROUP,
});

export const userRequestToJoinGroup = (groupId) => ({
  type: USER_REQUEST_TO_JOIN_GROUP,
  groupId,
});

export const updateStudyGroupRequest = (payload) => ({
  type: UPDATE_STUDY_GROUP_REQUEST,
  payload,
});

export const userCancelRequestStudyGroup = (payload) => ({
  type: USER_CANCEL_REQUEST_STUDY_GROUP,
  payload,
});



// WEBPACK FOOTER //
// ./src/actions/studygroups.js